import { render } from "./UbigeoMaestro.vue?vue&type=template&id=acf8fba8"
import script from "./UbigeoMaestro.vue?vue&type=script&lang=js"
export * from "./UbigeoMaestro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__